/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-time-offset-picker .timepicker-group{display:flex}ui-time-offset-picker .timepicker-group .timepicker{margin-left:15px;width:50%}"];
export { styles as styles };
